import { Fragment, useEffect, useRef, useState } from 'react';
import { Container, Flex, Box } from 'theme-ui';
import { observer } from 'mobx-react-lite';
import styles from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModal/ProductGalleryBlockModal.styles';
import { IParsedImage } from '@components/typescript';
import { TProductGallerySlide } from '@features/cms/typescript';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import ProductState from '@features/categories/mobx/state/ProductState';
import ProductCard from '@components/ProductCardNew/ProductCard';
import RenderMedia from '@utils/RenderMedia';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
type PropsType = {
  isActive: boolean;
  slide: TProductGallerySlide<IParsedImage>;
  onClose: () => void;
};
const ProductGalleryBlockModal = ({
  isActive,
  slide,
  onClose
}: PropsType) => {
  const {
    products,
    image,
    video
  } = slide;
  const [productContainerHeight, setProductContainerHeight] = useState<number | undefined>();
  const productContainerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (productContainerRef.current) {
      setProductContainerHeight(productContainerRef.current.getBoundingClientRect().height);
    }
    return () => setProductContainerHeight(0);
  }, [productContainerRef.current]);
  return <div sx={styles.modal(slide && isActive)}>
      <div sx={styles.modalCloseButton}>
        <Button variant="iconOnly" onClick={onClose}>
          <Icon icon="Close2" size={['16px', '16px', '21px', '21px', '24px']} />
        </Button>
      </div>
      <div>
        <Container variant="fluid">
          <Flex sx={styles.modalContentFlexContainer}>
            <Box sx={styles.modalContentImageBox(productContainerHeight)}>
              <div sx={styles.imageContainer}>
                {RenderMedia(image.image, video || BLANK_VIDEO_OBJECT, true, {
                image: image.image,
                blur: image?.blur || BLANK_VIDEO_OBJECT
              }, '', true, '50%')}
              </div>
            </Box>
            <Box sx={styles.modalContentProductsBox} ref={productContainerRef}>
              <div sx={styles.modalContentOverflow}>
                <div sx={styles.modalContentProductsGrid}>
                  {products.map(product => {
                  const productState = new ProductState(product);
                  return (
                    // @ts-expect-error - React 19 compatibility issue with Fragment types
                    <Fragment key={productState.id}>
                        <div sx={styles.modalContentProduct}>
                          <ProductCard product={productState} fromModal />
                        </div>
                      </Fragment>
                  );
                })}
                </div>
              </div>
            </Box>
          </Flex>
        </Container>
      </div>
    </div>;
};
export default observer(ProductGalleryBlockModal);